import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wild-sand py-40 px-30" }

import ProductImage from '@/shared/media/ProductImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverlaySpotImage',
  props: {
    sku: null,
    cacheBust: { default: undefined },
    widthOnScreen: { default: 1 }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProductImage, {
      sku: __props.sku,
      "aspect-ratio": 4/3,
      "width-on-screen": __props.widthOnScreen,
      "cache-bust": __props.cacheBust
    }, null, 8, ["sku", "width-on-screen", "cache-bust"])
  ]))
}
}

})